import {ProductCounter} from 'modules/product-card/components/ProductCounter';
import {FC} from 'react';
import {useProductCounter} from 'hooks/product/useProductCounter';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {MAX_COUNTER_VALUE} from 'core/constants';

export const ProductBuyCartCounter: FC = () => {
    const productData = useAppSelector(selectProductData);

    const stockAmount = productData?.stockAmount ?? MAX_COUNTER_VALUE;

    const {count, handleChange, handleDecrement, handleIncrement} = useProductCounter(stockAmount);

    return (
        <div>
            <ProductCounter
                count={count}
                onChange={handleChange}
                onDecrement={handleDecrement}
                onIncrement={handleIncrement}
                disabledIncrement={
                    (Boolean(stockAmount) && count !== undefined && count >= stockAmount) ||
                    (count !== undefined && count >= stockAmount)
                }
            />
        </div>
    );
};
